import { useState } from "react";
import { Icon } from "@/components/icon";
import { usePath } from "../../../contexts/path/path";
import ReviewsButton from "./reviewsButton";
import StatsButton from "./statsButton";
import { QuickFilters } from "../../filters/quick/filters";
import css from "./.module.scss";

function DistrictHeader() {
  const { district, quickFields } = usePath();
  const [isFiltersExpand, setIsFiltersExpand] = useState(false);

  return (
    <>
      {district && <QuickFilters showMore={isFiltersExpand} />}
      {district && (
        <div className={css.districtBadges}>
          {quickFields?.length > 1 && !!quickFields[1].length && (
            <button
              type="button"
              className={css.showFiltersBtn}
              onClick={() => setIsFiltersExpand((prev) => !prev)}
            >
              <Icon
                className={css.callIcon}
                name={isFiltersExpand ? "less" : "more"}
                width={20}
                height={20}
              />
              <span>{isFiltersExpand ? "إخفاء الفلاتر" : "فلاتر إضافية"}</span>
            </button>
          )}
          <div className={css.leftPanel}>
            <ReviewsButton />
            <StatsButton />
          </div>
        </div>
      )}
    </>
  );
}

export default DistrictHeader;
